export const WHATSAPP_CONTACTS = [
  {
    name: "Gabriel",
    phone: "11986040769",
    displayPhone: "(11) 98604-0769",
  },
  {
    name: "Robson",
    phone: "11975648252",
    displayPhone: "(11) 97564-8252",
  },
];

export function buildWhatsAppLink(phone, message = "") {
  const text = message ? `&text=${encodeURIComponent(message)}` : "";
  return `https://api.whatsapp.com/send?phone=55${phone}${text}`;
}
